/* ------------------------------------------------------------------
   Size guide dialog behaviour.

   Loaded only by snippets/size-guide-dialog.liquid, which renders only
   when a main-product "Size guide" block exists on the page.

   Single column, no tabs: it opens, closes and defers images, nothing else.

   Touches nothing outside its own dialog. It never reads or writes the
   product form, a variant input, the quantity field, the cart or any
   checkout element, so opening and closing cannot reset a selection.

   Listeners are delegated from document, so a Theme Editor re-render of
   the section keeps working without re-initialising anything.
   ------------------------------------------------------------------ */
(function () {
  'use strict';

  if (window.pproSizeGuideLoaded) return;
  window.pproSizeGuideLoaded = true;

  var scrollLock = { depth: 0, y: 0, saved: null };

  function lockScroll() {
    if (scrollLock.depth++ > 0) return;
    var body = document.body;
    var gutter = window.innerWidth - document.documentElement.clientWidth;
    scrollLock.y = window.pageYOffset || document.documentElement.scrollTop || 0;
    scrollLock.saved = {
      position: body.style.position,
      top: body.style.top,
      width: body.style.width,
      overflow: body.style.overflow,
      paddingRight: body.style.paddingRight
    };
    body.style.position = 'fixed';
    body.style.top = -scrollLock.y + 'px';
    body.style.width = '100%';
    body.style.overflow = 'hidden';
    if (gutter > 0) body.style.paddingRight = gutter + 'px';
  }

  function unlockScroll() {
    if (scrollLock.depth === 0) return;
    if (--scrollLock.depth > 0) return;
    var body = document.body;
    var saved = scrollLock.saved || {};
    body.style.position = saved.position || '';
    body.style.top = saved.top || '';
    body.style.width = saved.width || '';
    body.style.overflow = saved.overflow || '';
    body.style.paddingRight = saved.paddingRight || '';
    window.scrollTo(0, scrollLock.y);
  }

  /* Images carry their real source in data-ppro-src and only fetch on first open. */
  function loadMedia(dialog) {
    var pending = dialog.querySelectorAll('img[data-ppro-src]');
    for (var i = 0; i < pending.length; i++) {
      pending[i].src = pending[i].getAttribute('data-ppro-src');
      pending[i].removeAttribute('data-ppro-src');
    }
  }

  /* Men / Women switch inside a section. Roving tabindex, arrows, Home and End. */
  function selectTab(group, index) {
    var tabs = group.querySelectorAll('[data-ppro-sg-tab]');
    if (!tabs.length) return;
    if (index < 0) index = tabs.length - 1;
    if (index >= tabs.length) index = 0;
    for (var i = 0; i < tabs.length; i++) {
      var on = i === index;
      tabs[i].setAttribute('aria-selected', String(on));
      tabs[i].setAttribute('tabindex', on ? '0' : '-1');
      var panel = document.getElementById(tabs[i].getAttribute('aria-controls'));
      if (panel) panel.setAttribute('data-selected', on ? 'true' : 'false');
    }
    return tabs[index];
  }

  function focusables(dialog) {
    var nodes = dialog.querySelectorAll(
      'button:not([disabled]), a[href], input:not([disabled]), select:not([disabled]), textarea:not([disabled]), [tabindex]:not([tabindex="-1"])'
    );
    var out = [];
    for (var i = 0; i < nodes.length; i++) {
      if (nodes[i].offsetWidth || nodes[i].offsetHeight || nodes[i].getClientRects().length) out.push(nodes[i]);
    }
    return out;
  }

  function openDialog(dialog, trigger) {
    if (!dialog || dialog.hasAttribute('open')) return;
    dialog.pproTrigger = trigger || null;
    loadMedia(dialog);
    if (typeof dialog.showModal === 'function') {
      dialog.showModal();
    } else {
      dialog.setAttribute('open', '');
      dialog.pproManualTrap = true;
    }
    lockScroll();
    var close = dialog.querySelector('[data-ppro-sg-close]');
    if (close) close.focus();
  }

  function closeDialog(dialog) {
    if (!dialog || !dialog.hasAttribute('open')) return;
    if (typeof dialog.close === 'function') {
      dialog.close();
    } else {
      dialog.removeAttribute('open');
      afterClose(dialog);
    }
  }

  function afterClose(dialog) {
    unlockScroll();
    var trigger = dialog.pproTrigger;
    dialog.pproTrigger = null;
    if (trigger && typeof trigger.focus === 'function') trigger.focus();
  }

  document.addEventListener('click', function (event) {
    var target = event.target;
    if (!target || typeof target.closest !== 'function') return;

    var opener = target.closest('[data-ppro-sg-open]');
    if (opener) {
      event.preventDefault();
      var id = opener.getAttribute('data-ppro-sg-open');
      openDialog(document.getElementById(id), opener);
      return;
    }

    var tab = target.closest('[data-ppro-sg-tab]');
    if (tab) {
      event.preventDefault();
      selectTab(tab.closest('[role="tablist"]'), Number(tab.getAttribute('data-ppro-sg-tab')));
      return;
    }

    var closer = target.closest('[data-ppro-sg-close]');
    if (closer) {
      event.preventDefault();
      closeDialog(closer.closest('dialog.ppro-sg'));
      return;
    }

    /* A click on the dimmed backdrop is reported with the dialog itself as target. */
    if (target.tagName === 'DIALOG' && target.classList.contains('ppro-sg')) {
      closeDialog(target);
    }
  });

  /* close does not bubble, so listen in the capture phase. */
  document.addEventListener(
    'close',
    function (event) {
      var dialog = event.target;
      if (dialog && dialog.tagName === 'DIALOG' && dialog.classList.contains('ppro-sg')) afterClose(dialog);
    },
    true
  );

  document.addEventListener('keydown', function (event) {
    var dialog = document.querySelector('dialog.ppro-sg[open]');
    if (!dialog) return;

    var focusedTab = document.activeElement && document.activeElement.closest
      ? document.activeElement.closest('[data-ppro-sg-tab]')
      : null;
    if (focusedTab && ['ArrowLeft', 'ArrowRight', 'Home', 'End'].indexOf(event.key) !== -1) {
      event.preventDefault();
      var group = focusedTab.closest('[role="tablist"]');
      var all = group.querySelectorAll('[data-ppro-sg-tab]');
      var at = Array.prototype.indexOf.call(all, focusedTab);
      var to = event.key === 'Home' ? 0
             : event.key === 'End' ? all.length - 1
             : event.key === 'ArrowLeft' ? at - 1 : at + 1;
      var moved = selectTab(group, to);
      if (moved) moved.focus();
      return;
    }

    if (event.key === 'Escape' && dialog.pproManualTrap) {
      event.preventDefault();
      closeDialog(dialog);
      return;
    }

    /* Native showModal already traps Tab. This only covers browsers without it. */
    if (event.key === 'Tab' && dialog.pproManualTrap) {
      var items = focusables(dialog);
      if (!items.length) return;
      var first = items[0];
      var last = items[items.length - 1];
      if (event.shiftKey && document.activeElement === first) {
        event.preventDefault();
        last.focus();
      } else if (!event.shiftKey && document.activeElement === last) {
        event.preventDefault();
        first.focus();
      }
    }
  });
})();
